import { CommandType } from "../../../../common/services/cqs/CommandType";
import { SkogsvardTradslagPlantaBaseCommand } from "./SkogsvardTradslagPlantaBaseCommand";

export class DeleteSkogsvardTradslagPlantaCommand extends SkogsvardTradslagPlantaBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DeleteSkogsvardTradslagPlantaCommand";

    constructor(atgardGuid: string, guid: string) {
        super(atgardGuid, guid, DeleteSkogsvardTradslagPlantaCommand.$type, CommandType.Delete);
    }
}
